import { http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { EmploymentNote } from './employment-note.interface';

const baseUrl = `/employment-notes`;

export class EmploymentNoteService {
   async getEmploymentNotes(query: any) {
      return await http
         .get<PaginatedResponse<Array<EmploymentNote>>>(baseUrl, {
            params: { ...query, page: 1, per_page: 500, embed: 'performanceCode' },
         })
         .then((response) => response.data);
   }

   async postEmploymentNote(body: any) {
      return await http
         .post<EmploymentNote>(baseUrl, body, { params: { embed: 'performanceCode' } })
         .then((response: any) => response.data);
   }

   async removeEmploymentNote(employmentNoteId: number) {
      return await http.post(baseUrl).then((response) => response.data);
   }
}
